import { assistance, KeyCode } from '@/utils';
import CountDown from '@/components/v-count-down.vue';
// import { reasonList } from '../constant';
import {
  saveAppealInfo,
} from '@/fetch/supplierAppeal';

export default {
  components: {
    CountDown,
  },
  data() {
    return {
      previewImg: {
        imgArr: [],
        index: 0,
        canEdit: false,
        deleteImage: () => { },
        uploadImage: () => { },
      },
      compensationNorAppealDetail: {
        orderInfo: {
          orderNo: '',
          partsName: '',
          carBrand: '',
          count: null,
          createTime: '',
        },
        checkInfo: {
          status: null,
          compensationAmount: null,
          compensationReason: null,
          createTime: '',
          duty: '',
          countDownMills: '',
          messageToSupplier: '',
        },
        appealInfo: {
          haveGoods: 0,
          appeal: 0,
          reason: 0,
          duty: 0,
          explain: '',
          pics: [],
          supplierOrderCutTime: '',
          supplierOrderCreateTime: '',
          timeout: false,
        },
        appealResult: {
          status: null,
          compensationAmount: null,
          deal: '',
          duty: '',
          auditRemark: '',
          auditTime: '',
        },
        type: 1,
      },
      dialogImageUrl: '',
      pictureDialogVisible: false,
      dutyList: [

      ],
      compensationList: [
        { value: 0, text: '待确认赔付' },
        { value: 1, text: '已确认赔付' },
        { value: 2, text: '不赔付' },
        { value: -1, text: '未知' },
      ],
      responsibleDepartment: '',
      reasonList: [],
    };
  },
  watch: {

  },
  computed: {
    isNeedAdd() {
      const { appealInfo, type } = this.compensationNorAppealDetail;
      return (appealInfo.pics.length >= 3 && type === 0) || (appealInfo.pics.length <= 3 && type !== 0) ? 'upload-need' : '';
    },
    isShowAppealResult() {
      const { type, appealResult } = this.compensationNorAppealDetail;
      return (type === 4 && appealResult.status) || type === 1;
    },
  },
  created() {
    document.addEventListener('keydown', this.keysEvent);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keysEvent);
  },
  methods: {
    showSupplierPic(file) {
      const { pics } = this.compensationNorAppealDetail.appealInfo;
      const { type } = this.compensationNorAppealDetail;
      this.previewImg.imgArr = type === 0
        ? this.formatPics(pics)
        : pics.map(item => ({ url: item.url }));
      this.previewImg.index = type === 0
        ? pics.findIndex(item => item.response.result.data[0] === file.response.result.data[0])
        : pics.findIndex(item => item.url === file.url);
      this.previewImg.canEdit = false;
      this.previewImg.deleteImage = () => { };
      this.previewImg.uploadImage = () => { };
      this.togglePicPreview();
    },
    formatPics(pics) {
      const newPics = this.flatten(pics.map(item => item.response.result.data))
        .map(item => ({ url: item }));
      return newPics;
    },
    // 图片操作
    togglePicPreview() {
      this.$refs.picPreview.$emit('togglePad', true);
    },
    async dealSupplierAppeal() {
      const {
        appeal, haveGoods, reason, pics, duty, explain,
      } = this.compensationNorAppealDetail.appealInfo;
      if (appeal === 0 && (reason === 0 || duty === 0 || !reason || !duty)) {
        this.$refs.modal.$emit('ModalTip', '请填写责任方和具体原因');
      }
      const newPic = this.flatten(pics.map(item => item.response.result.data));
      const params = {
        deductionId: this.$route.params.id,
        appeal,
        haveGoods: appeal === 1 ? null : haveGoods,
        reason,
        pics: appeal === 1 ? [] : newPic,
        duty,
        explain,
      };
      const data = await saveAppealInfo(params);
      if (data.success) {
        this.handleGoBack();
      } else {
        this.$refs.modal.$emit('ModalTip', data.msg || '网络错误！');
      }
    },
    // 键盘事件
    keysEvent(e) {
      const modalMaps = {};
      const notModalMaps = {
        ESC: this.handleGoBack,
      };
      assistance.handleKeysEvent.call(this, e, modalMaps, notModalMaps);
    },
    handleRemove(file) {
      const { pics } = this.compensationNorAppealDetail.appealInfo;
      const existIndex = pics.findIndex(item => item.uid === file.uid);
      if (parseInt(existIndex, 10) >= 0) {
        this.compensationNorAppealDetail.appealInfo.pics.splice(existIndex, 1);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.pictureDialogVisible = true;
    },
    handleUploadImage(response, file, fileList) {
      this.compensationNorAppealDetail.appealInfo.pics = fileList;
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$refs.modal.$emit('ModalTip', '请勿上传超过2M的图片！！');
      }
      return isLt2M;
    },
    flatten(array) {
      return array.reduce((result, item) => result.concat(Array.isArray(item) ? this.flatten(item) : item), []);
    },
  },
};
